export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14459.bc696dcc.jpg";